module.exports = __webpack_public_path__ + "static/img/cp.03efa0eb.png";